import { QueryKeyTypes } from "../../assets/types/common";
import { Constants } from "../../assets/utils/lib/constants";
import { LookupDto } from "../../assets/utils/lib/lookupDto";

export namespace ViewProps {

    export interface CommunityLookupProps {
        state: LookupDto[] | undefined;
        county: LookupDto[] | undefined;
    }

    
    export const CommunityQueryKeys: Record<QueryKeyTypes, string> = {
        [QueryKeyTypes.None]: Constants.emptyString,
        [QueryKeyTypes.Get]: "communityQuery",
        [QueryKeyTypes.Grid]: "communityGridQuery",
        [QueryKeyTypes.Lookup]: "communitylookupsQuery",
        [QueryKeyTypes.GetAll]: "communitiesQuery",
    }

    export const CommunitySubscriptionQueryKeys: Record<QueryKeyTypes, string> = {
        [QueryKeyTypes.None]: Constants.emptyString,
        [QueryKeyTypes.Get]: "communitySubscriptionsQuery",
        [QueryKeyTypes.Grid]: "communitySubscriptionGridQuery",
        [QueryKeyTypes.Lookup]: "communitySubscriptionlookupsQuery",
        [QueryKeyTypes.GetAll]: "communitySubscriptionQuery",
    }
}